"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var locationsSlice_1 = require("@store/slices/locationsSlice");
var useHandleEmptyList_1 = require("@hooks/useHandleEmptyList");
var TableWithImages_1 = __importDefault(require("../TableWithImages"));
var locationsAPI_1 = require("@services/locationsAPI");
var modalSlice_1 = require("@store/slices/modalSlice");
var modalSlice_2 = require("@store/slices/modalSlice");
var withConfirmationModal_1 = __importDefault(require("@components/_hoc/withConfirmationModal"));
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var tableTranslator_1 = require("../localisation/tableTranslator");
function LocationsTable(_a) {
    var showConfirmationModal = _a.showConfirmationModal;
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = tableTranslator_1.tableTranslator[currentLang];
    var locations = (0, react_redux_1.useSelector)(function (state) { return state.locationsSlice.locations; });
    var dispatch = (0, react_redux_1.useDispatch)();
    var emptyLocationsHandler = (0, useHandleEmptyList_1.useHandleEmptyList)({ data: locations });
    if (emptyLocationsHandler)
        return emptyLocationsHandler;
    var sortedLocations = __spreadArray([], locations, true).sort(function (a, b) {
        return a.name.localeCompare(b.name);
    });
    function handleLocationDelete(id) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, locationsAPI_1.deleteLocationAPI)(id)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            dispatch((0, locationsSlice_1.deleteLocation)(id));
                            return [2 /*return*/];
                        }
                        dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_2.ActiveModal.Info, text: res.message }));
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_2.ActiveModal.Info, text: error_1 }));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function handleDeleteButtonClick(location) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!showConfirmationModal)
                    return [2 /*return*/];
                showConfirmationModal(loc.onDeleteMessage(location.name), function () {
                    return handleLocationDelete(location.id);
                });
                return [2 /*return*/];
            });
        });
    }
    function handleDup(item) {
        dispatch((0, locationsSlice_1.duplicateLocation)(item));
    }
    return ((0, jsx_runtime_1.jsx)(TableWithImages_1.default, { data: sortedLocations, handleDeteleItem: handleDeleteButtonClick, handleDup: handleDup, loc: loc }));
}
exports.default = (0, withConfirmationModal_1.default)(LocationsTable);
